// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingIcon_spinner__LM+vk","spin":"LoadingIcon_spin__6pG1A","container":"LoadingIcon_container__IZ4Ka"};